import { Container } from "@peracto/peracto-blocks-tailwind";

import TripleHero from "./TripleHero";
import ImageAndText from "./ImageAndText";
import InfoPanel from "./InfoPanel";
import LinkRow from "./LinkRow";
import MenuItems from "./MenuItems";
import Accordion from "./Accordion";
import SupportPanels from "./SupportPanels";
import Products from "./Products";
import SubCategory from "./SubCategory";

export default {
    plugins: {
        content: [
            Accordion,
            TripleHero,
            ImageAndText,
            InfoPanel,
            LinkRow,
            MenuItems,
            SupportPanels,
            Products,
            SubCategory,
        ],
        layout: [Container],
    },
};
